import {Component, EventEmitter, Output, inject} from '@angular/core';
import {NotificationService} from '../../service/Notification.service';

const MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024; // 50 MB

@Component({
  selector: 'app-match-tune-card',
  templateUrl: './match-tune-card.component.html',
  styleUrls: ['./match-tune-card.component.css']
})
export class MatchTuneCardComponent {

  private readonly notification = inject(NotificationService);

  @Output() fileSelected = new EventEmitter<File>();

  onFileDropped(file: File): void {
    if (file) {
      this.emitIfAllowed(file);
    }
  }

  onBrowseChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files?.[0]) {
      this.emitIfAllowed(input.files[0]);
      input.value = '';
    }
  }

  private emitIfAllowed(file: File): void {
    if (file.size > MAX_FILE_SIZE_BYTES) {
      this.notification.showErrorMessage(
        'File is too large. Maximum size is 50 MB.',
        'File too large'
      );
      return;
    }
    this.fileSelected.emit(file);
  }
}
